export default function ParameterValues(results) {
  const parameterValues = []
  for (let parameter of results.parameterValues) {
    const split = parameter.value.split('<br>')
    const values = []
    if (split.length > 1) {
      for (let i = 0; i < split.length; i++) {
        values.push(<span>{split[i]}<br/></span>)
      }
    } else {
      values.push(split[0])
    }
    parameterValues.push(<div key={parameter.name}><b>{parameter.name}: </b>{values}</div>)
  }
  return parameterValues
}